export const AutoPlayDelay = 4000
export const ScreenAutoPlaySpeed = 1600

export const AutoPlayConfig = {
  delay: AutoPlayDelay,
  disableOnInteraction: false,
  pauseOnMouseEnter: true,
}
